import { date, timestamp, uuid, } from 'drizzle-orm/pg-core';
import { users, technicians } from './schema';
/**
 * System audit timestamp fields (UTC).
 * Use for tracking record lifecycle: when created, updated, or deleted.
 *
 * @example
 * ```ts
 * export const myTable = pgTable('my_table', {
 *   id: uuid('id').primaryKey().defaultRandom(),
 *   ...auditTimestamps,
 * });
 * ```
 */
export const auditTimestamps = {
    createdAt: timestamp('created_at', { withTimezone: true }).defaultNow(),
    createdBy: uuid('created_by').references(() => users.id),
    updatedAt: timestamp('updated_at', { withTimezone: true }).defaultNow(),
    updatedBy: uuid('updated_by').references(() => users.id),
    deletedAt: timestamp('deleted_at', { withTimezone: true }),
    deletedBy: uuid('deleted_by').references(() => users.id),
};
export const technicianAuditTimestamps = {
    createdByTechnicianId: uuid('created_by_technician_id').references(() => technicians.id),
    updatedByTechnicianId: uuid('updated_by_technician_id').references(() => technicians.id),
    deletedByTechnicianId: uuid('deleted_by_technician_id').references(() => technicians.id),
};
/**
 * Business date (calendar date without time component).
 * Timezone-agnostic, represents a calendar day.
 *
 * **Use for:**
 * - Installation dates
 * - Warranty start/end dates
 * - Contract effective dates
 * - Invoice due dates
 * - Any calendar date without specific time
 *
 * @example
 * ```ts
 * installationDate: businessDate('installation_date')
 * warrantyEndDate: businessDate('warranty_end_date').notNull()
 * ```
 */
export function businessDate(columnName, options) {
    return date(columnName, options);
}
